import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  isPicUpdate: boolean;
  userRole?: string;
}

const initialState: InitialState = {
  isPicUpdate: false,
  userRole: "",
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  reducers: {
    setProfilePic: (state, action: PayloadAction<{ isPicUpdate: boolean }>) => {
      state.isPicUpdate = action.payload.isPicUpdate;
    },
    setUserRole: (state, action: PayloadAction<string>) => {
      state.userRole = action.payload;
    },
  },
});

export const { setProfilePic, setUserRole } = settingSlice.actions;
export default settingSlice.reducer;
